import * as React from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import {
  Label,
} from '../form';

export default function FormRow({ label, hideDivider, children }) {
  return (
    <>
      <Grid item xs={12} sm={3}>
        <Label>{label}</Label>
      </Grid>
      <Grid item xs={12} sm={9}>
        {children}
      </Grid>
      {!hideDivider && (
        <Grid item xs={12} sm={12} mt={2} mb={2}>
          <Divider />
        </Grid>
      )}
    </>
  );
}
